/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../../../components/ui/button';
import { cn } from '../../../../lib/utils';

function SourceFilter({ sources, activeSource, onSourceChange }) {
  return (
    <div className="flex flex-wrap gap-2">
      <Button
        variant={activeSource === 'all' ? 'default' : 'outline'}
        size="sm"
        onClick={() => onSourceChange('all')}
        className={cn(activeSource === 'all' && 'bg-primary')}
      >
        All Sources
      </Button>
      {sources.map((source) => (
        <Button
          key={source.name}
          variant={activeSource === source.name ? 'default' : 'outline'}
          size="sm"
          onClick={() => onSourceChange(source.name)}
          className={cn('gap-1', activeSource === source.name && 'bg-primary')}
        >
          <span>{source.icon}</span>
          {source.name}
        </Button>
      ))}
    </div>
  );
}

SourceFilter.propTypes = {
  sources: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
    }),
  ).isRequired,
  activeSource: PropTypes.string.isRequired,
  onSourceChange: PropTypes.func.isRequired,
};

export default SourceFilter;
